export default {
  methods: {
    shakeIt({ x, y }) {
      const elsArr = [...this.$el.querySelectorAll('.cls-2')]

      elsArr.forEach((el, i) => {
        TweenMax.to(el, 0.1, {
          x: x * 0.04,
          y: y * -0.04,
          rotation: x * 0.006,
          ease: Power2.easeInOut
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./mixins/HomeDoodle.js